export default __webpack_public_path__ + "static/media/mexico-flag.71c1577f.svg";